import React from 'react'

function Decor() {
  return (
    <div>Decor</div>
  )
}

export default Decor